
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
}
